var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1189_12458)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1189_12458",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V60H60V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1189_12458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4167 15.336L50.0008 3.5407C49.21 2.43611 48.1672 1.53602 46.9589 0.915143C45.7506 0.294265 44.4117 -0.0295039 43.0532 -0.0292968H16.9461C15.5897 -0.0275415 14.2533 0.297167 13.0473 0.917964C11.8413 1.53876 10.8004 2.4378 10.0108 3.5407L1.5932 15.3448C0.527001 16.8563 -0.0225208 18.6717 0.0264481 20.5208C0.075417 22.3698 0.720257 24.1536 1.86496 25.6066L30.005 60.276L58.1785 25.5554C59.311 24.1037 59.9457 22.3258 59.9887 20.4851C60.0316 18.6444 59.4804 16.8389 58.4167 15.336ZM7.69025 19.6948L16.115 7.90129C16.2097 7.769 16.3344 7.66102 16.4788 7.58618C16.6233 7.51134 16.7834 7.47177 16.9461 7.4707H24.2485L20.6855 21.2513H39.3138L35.7508 7.4707H43.0638C43.2268 7.47149 43.3873 7.51093 43.5321 7.58578C43.6769 7.66064 43.8018 7.76876 43.8967 7.90129L52.3197 19.6931C52.4448 19.8642 52.5132 20.0702 52.5154 20.2823C52.5177 20.4943 52.4535 20.7017 52.332 20.8754L52.0267 21.2513H39.3208L30.005 48.3713L20.6891 21.2513H7.98319L7.71496 20.9213C7.57933 20.7473 7.50335 20.5342 7.49826 20.3136C7.49318 20.093 7.55926 19.8767 7.68672 19.6966L7.69025 19.6948Z",
    fill: "#ACF564"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1189_12458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature-1.33f9c597db3ec267d0086a9da0264167.svg";
export { ForwardRef as ReactComponent };